import config from "../../../config";
// import eventBus from "../../../event-bus/eventBus";
import sendRequest from "../../../helpers/requestHelper";

const getInvoiceClientPersons = {
    namespaced: true,
    state: {
        clientPersons: [],
        areClientPersonsFetching: false,
    },

    mutations: {
        GET_CLIENT_PERSONS_SUCCESS(state, response) {
            state.clientPersons = response.data.data;
            state.areClientPersonsFetching = false;
        },
        GET_CLIENT_PERSONS_FAILURE(state, error) {
            console.log(error);
            state.areClientPersonsFetching = false;
        },
    },
    actions: {
        getInvoiceClientPersons: function({ dispatch, state }, payload) {
            let promise = sendRequest("get", config.baseURLApi + "/invoices/" + payload.creds.id + "/client-persons", {}, {}, true);
            state.areClientPersonsFetching = true;
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetClientPersons", result[1]);
                } else {
                    dispatch("failureGetClientPersons", result[1]);
                }
            });
        },
        successGetClientPersons: function({ commit }, response) {
            commit("GET_CLIENT_PERSONS_SUCCESS", response);
        },
        failureGetClientPersons: function({ commit }, error) {
            commit("GET_CLIENT_PERSONS_FAILURE", error);
        },
    }
}

export default getInvoiceClientPersons;